import {Navigate, Outlet} from "react-router-dom";
import {usePatAuth} from "../context/PatAuthContext";
const PatPrivateRoute = ({allowedRoles}) => {
    const {patient} = usePatAuth();
    if (!patient) {
        return <Navigate to="/patient-login" replace/>;
    }
    if (!allowedRoles.includes(patient.role)) {
        return <Navigate to="/patient-login" replace/>;
    }
    return <Outlet/>;
};
export default PatPrivateRoute;